<template>
  <b-container class="mt-5">
    <m-payment-1 side-bar-continue-text="ثبت و پرداخت" />
  </b-container>
</template>

<script>

export default {
  name: "Payment",
}
</script>

<style scoped>

</style>